import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type CallsPageStore } from 'pages/conversations/pages/calls/store/callsPageStore'

export const CallsPageContext = createContext<CallsPageStore | null>(null)

export const useCallsPageContext = () => {
  const context = useContext(CallsPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with CallsPageContext')

  return context
}

type IProviderCallsPageProps = {
  value: CallsPageStore
  children: ReactNode
}

export const ProviderCallsPage: FC<IProviderCallsPageProps> = ({ value, children }) => {
  return <CallsPageContext.Provider value={value}>{children}</CallsPageContext.Provider>
}
